export * from "./issue-points-additional-details.component";
